import { StateUtils } from '@spartacus/core';
import { ORDER_REPEAT } from '../order-state';

export const OFFLINE_ORDER_REPEAT = '[Order] Offline Order Repeat';
export const OFFLINE_ORDER_REPEAT_SUCCESS = '[Order] Offline Order Repeat Success';
export const OFFLINE_ORDER_REPEAT_FAIL = '[Order] Offline Order Repeat Fail';

export class OfflineOrderRepeat extends StateUtils.LoaderLoadAction {
  readonly type = OFFLINE_ORDER_REPEAT;

  constructor(public payload: { orderCode: string }) {
    super(ORDER_REPEAT);
  }
}

export class OfflineOrderRepeatSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = OFFLINE_ORDER_REPEAT_SUCCESS;

  constructor() {
    super(ORDER_REPEAT);
  }
}

export class OfflineOrderRepeatFail extends StateUtils.LoaderFailAction {
  readonly type = OFFLINE_ORDER_REPEAT_FAIL;

  constructor(public payload: unknown) {
    super(ORDER_REPEAT, payload);
  }
}

export type OfflineOrderRepeatActions = OfflineOrderRepeat | OfflineOrderRepeatSuccess | OfflineOrderRepeatFail;
